import axios from 'axios'
import { EXCLUIR_CONTROLE_EMISSAO_BPE_USUARIO } from '../types'
import { URL } from '../../util/ambienteActions';
import {SLOW_REQUEST_HEADER} from '../../util/loadingUtil';

export default function excluirControleEmissaoBpeUsuario (id) {
  const url = `${URL}/controle-emissao-bpe-usuario/${id}`;

  return dispatch => axios.delete(url, SLOW_REQUEST_HEADER).then(
      response => dispatch({
        type: EXCLUIR_CONTROLE_EMISSAO_BPE_USUARIO,
        payload: response
      })
  );
}


